// Flag icons component for language selector
interface FlagIconProps {
  className?: string;
}

export function USFlag({ className }: FlagIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <path fill="#f0f0f0" d="M0 85.33h512v341.33H0z"/>
      <path fill="#d80027" d="M0 85.33h512V128H0zm0 85.34h512v42.66H0zm0 85.33h512v42.67H0zm0 85.33h512v42.67H0z"/>
      <path fill="#2e52b2" d="M0 85.33h256v256H0z"/>
      <path fill="#f0f0f0" d="m99.82 160.624-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77z"/>
      <path fill="#f0f0f0" d="m99.82 160.624-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77z"/>
      <path fill="#f0f0f0" d="m99.82 223.964-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77zm64.32-127-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77zm-10.64 63.34-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77zm10.64 63.34-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77zm64.33-127-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77zm0 63.34-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77zm0 63.34-23.93 17.32 9.11 27.79-23.81-17.34-23.81 17.34 9.09-27.79-23.83-17.32 29.46-.02 9.09-27.77 9.09 27.77z"/>
    </svg>
  );
}

export function CNFlag({ className }: FlagIconProps) {
  return (
    <svg 
      className={className} 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 512 512"
    >
      <path fill="#D80027" d="M0 85.33h512v341.33H0z"/>
      <path fill="#FFDA44" d="m226.8 140.3 9.2 28.4h29.8l-24.1 17.5 9.2 28.4-24.1-17.5-24.1 17.5 9.2-28.4-24.1-17.5h29.8zm-70.4 69.3 5.5 17.5h18l-14.6 10.6 5.5 17.1-14.4-10.6L142 255l5.5-17.1-14.5-10.6h18zm146.3-11.1-14.5 10.6 5.5 17.1L279 215l-14.5 11 5.5-17.5-14.5-10.6h18l5.5-17.1 5.5 17.1zm-11.7 62.2-14.5 10.6 5.5 17.5-14.5-11-14.5 11 5.5-17.5-14.5-10.6h18l5.5-17.1 5.5 17.1zm-70.8 11.1-14.5 10.6 5.5 17.5-14.5-11-14.5 11 5.5-17.5-14.5-10.6h18l5.5-17.5 5.5 17.5z"/>
    </svg>
  );
}
